export const NON_LOCAL_MARKET_TENANCIES: Set<string> = new Set([
  "Anomaly-Detection",
  // "Cloud Engineering",
  "Germany (VF-DE)",
  "PCS API Integrations",
  "TestOpCo101",
  "TestOpCo303",
  "TestOpCo505",
  "TestOpCo707",
  "VCI-Capacity-Management",
  "VCI-DRCC",
  "VCI-Security-Compliance",
  "VFDE-CBU-DIGITAL-Engineering",
  "VF_IT",
  "VGSL",
  "VGSL TEST",
  // "VOIS INDIA",
  "_vois hungary",
  "_vois india",
  "_vois india - crayon",
  "_vois romania",
  "blueprint management group",
  "brm",
  "drcc",
  "gks",
  "looker",
  "nucleus",
  // "oit.coll.billing",
  "oneuam",
  "pcs-ops-test-tenancy",
  "pcs_drcc",
  "snow",
  // "support functions",
  "technology-vois-india",
  // "tenant root group",
  "vams",
]);

export const AZURE_LOCAL_MARKET_MAPPINGS: Map<string, string> = new Map<string, string>([
  ["VC-TZ", "VC TZ"],
  ["vc-tz", "VC TZ"],
  ["vc.tz", "VC TZ"],
  ["vf-tr", "VF TR"],
  ["vf.group.aibooster", "AI Booster"],
  ["vf.group.architecture", "Group Architecture"],
  ["vf.group.cis", "Group CIS"],
  ["vf.group.cloud.analytics", "Group Cloud Analytics"],
  ["vf.group.consumer.products", "Group Consumer Products"],
  ["vf.group.cyber.security", "cyber security"],
  ["vf.group.enterprise.products", "Group Enterprise Products"],
  ["vf.group.tss", "Group TSS"],
  ["vf.group.vci", "VCI"],
  ["vod.al.migr.mgd", "VF AL"],
  ["vod.al.migr.ssm", "VF AL"],
  ["vod.cz.migr.ssm", "VF CZ"],
  ["vod.cz.online.aib", "VF CZ"],
  ["vod.cz.plt.conn", "VF CZ"],
  ["vod.cz.plt.mgmt", "VF CZ"],
  ["vod.cz.plt.migr", "VF CZ"],
  ["vod.cz.wl.mgd", "VF CZ"],
  ["vod.cz.wl.ssm", "VF CZ"],
  ["vod.de.migr.mgd", "VF DE"],
  ["vod.de.plt.conn", "VF DE"],
  ["vod.de.plt.mgmt", "VF DE"],
  ["vod.de.plt.migr", "VF DE"],
  ["vod.de.plt.sec", "VF DE"],
  ["vod.de.sbox", "VF DE"],
  ["vod.de.wl.mgd", "VF DE"],
  ["vod.de.wl.sle", "VF DE"],
  ["vod.de.wl.ssm", "VF DE"],
  ["vod.eg.migr.ssm", "VF EG"],
  ["vod.es.migr.mgd", "VF ES"],
  ["vod.es.migr.ssm", "VF ES"],
  ["vod.gr.decom", "VF GR"],
  ["vod.gr.migr.mgd", "VF GR"],
  ["vod.gr.migr.ssm", "VF GR"],
  ["vod.gr.plt.conn", "VF GR"],
  ["vod.gr.plt.mgmt", "VF GR"],
  ["vod.gr.plt.migr", "VF GR"],
  ["vod.gr.plt.sec", "VF GR"],
  ["vod.gr.wl.mgd", "VF GR"],
  ["vod.gr.wl.sle", "VF GR"],
  ["vod.gr.wl.ssm", "VF GR"],
  ["vod.group.cis.plt.mgmt", "Group CIS"],
  ["vod.group.cis.wl.mgd", "Group CIS"],
  ["vod.group.cis.wl.ssm", "Group CIS"],
  ["vod.group.dt.online.ssm", "Group Digital Twin"],
  ["vod.group.fin.wl.mgd", "Group Finance"],
  ["vod.group.it4it.wl.mgd", "IT4IT"],
  ["vod.group.itsa.sbox", "Group Architecture"],
  ["vod.group.oit.wl.ssm", "Oit-Coll-Billing"],
  ["vod.group.plt.mgmt", "VCI"],
  ["vod.group.vci.sbox", "VCI"],
  ["vod.group.vci.wl.mgd", "VCI"],
  ["vod.group.vits.wl.mgd", "VCI"],
  ["vod.ie.decom", "VF IE"],
  ["vod.ie.migr.mgd", "VF IE"],
  ["vod.ie.migr.ssm", "VF IE"],
  ["vod.ie.plt.conn", "VF IE"],
  ["vod.ie.plt.mgmt", "VF IE"],
  ["vod.ie.plt.migr", "VF IE"],
  ["vod.ie.plt.sec", "VF IE"],
  ["vod.ie.wl.mgd", "VF IE"],
  ["vod.ie.wl.sle", "VF IE"],
  ["vod.it.decom", "VF IT"],
  ["vod.it.migr.mgd", "VF IT"],
  ["vod.it.migr.ssm", "VF IT"],
  ["vod.it.plt.conn", "VF IT"],
  ["vod.it.plt.mgmt", "VF IT"],
  ["vod.it.plt.migr", "VF IT"],
  ["vod.it.plt.sec", "VF IT"],
  ["vod.it.wl.mgd", "VF IT"],
  ["vod.it.wl.ssm.next", "VF IT"],
  ["vod.lu.migr.mgd", "VF LU"],
  ["vod.lu.migr.ssm", "VF LU"],
  ["vod.migr.wl.mgd.group.vci", "VCI"],
  ["vod.pt.decom", "VF PT"],
  ["vod.pt.migr.mgd", "VF PT"],
  ["vod.pt.migr.ssm", "VF PT"],
  ["vod.pt.plt.conn", "VF PT"],
  ["vod.pt.plt.mgmt", "VF PT"],
  ["vod.pt.plt.migr", "VF PT"],
  ["vod.pt.plt.sec", "VF PT"],
  ["vod.pt.wl.mgd", "VF PT"],
  ["vod.pt.wl.sle", "VF PT"],
  ["vod.ro.decom", "VF RO"],
  ["vod.ro.migr.ssm", "VF RO"],
  ["vod.ro.plt.conn", "VF RO"],
  ["vod.ro.plt.mgmt", "VF RO"],
  ["vod.ro.plt.migr", "VF RO"],
  ["vod.ro.plt.sec", "VF RO"],
  ["vod.ro.sbox", "VF RO"],
  ["vod.ro.wl.mgd", "VF RO"],
  ["vod.ro.wl.sle", "VF RO"],
  ["vod.ro.wl.ssm", "VF RO"],
  ["vod.sbox", "VCI"],
  ["vod.shp.conn", "VCI"],
  ["vod.shp.hci", "VCI"],
  ["vod.shp.id", "VCI"],
  ["vod.shp.mgmt", "VCI"],
  ["vod.shp.sec", "VCI"],
  ["vod.tr.migr.ssm", "VF TR"],
  ["vod.tr.plt.mgmt", "VF TR"],
  ["vod.tz.migr.ssm", "VC TZ"],
  ["vod.uk.decom", "VF UK"],
  ["vod.uk.migr.mgd", "VF UK"],
  ["vod.uk.online.aib", "VF UK"],
  ["vod.uk.plt.conn", "VF UK"],
  ["vod.uk.plt.id", "VF UK"],
  ["vod.uk.plt.mgmt", "VF UK"],
  ["vod.uk.plt.migr", "VF UK"],
  ["vod.uk.plt.sec", "VF UK"],
  ["vod.uk.sbox", "VF UK"],
  ["vod.uk.wl.mgd", "VF UK"],
  ["vod.uk.wl.slb", "VF UK"],
  ["vod.uk.wl.sle", "VF UK"],
  ["vod.ziggo.migr.ssm", "VF ZIGGO"],
  ["tenant root group", "VCI"],
  ["skg-mgmt-group", "skg-mgmt-group"],
  ["vod.al.decom", "VF AL"],
  ["vod.al.migr mgd", "VF AL"],
  ["vod.al.migr ssm", "VF AL"],
  ["vod.cz.decom", "VF CZ"],
  ["vod.cz.migr.mgd", "VF CZ"],
  ["vod.cz.migr.ssm", "VF CZ"],
  ["vod.cz.online.aib", "VF CZ"],
  ["vod.cz.plt.conn", "VF CZ"],
  ["vod.cz.plt.id", "VF CZ"],
  ["vod.cz.plt.mgmt", "VF CZ"],
  ["vod.cz.plt.migr", "VF CZ"],
  ["vod.cz.plt.sec", "VF CZ"],
  ["vod.cz.sbox", "VF CZ"],
  ["vod.cz.wl.mgd", "VF CZ"],
  ["vod.cz.wl.ssm", "VF CZ"],
  ["vod.de.decom", "VF DE"],
  ["vod.de.migr.mgd", "VF DE"],
  ["vod.de.migr.ssm", "VF DE"],
  ["vod.de.online.aib", "VF DE"],
  ["vod.de.plt.conn", "VF DE"],
  ["vod.de.plt.id", "VF DE"],
  ["vod.de.plt.mgmt", "VF DE"],
  ["vod.de.plt.migr", "VF DE"],
  ["vod.de.plt.sec", "VF DE"],
  ["vod.de.sbox", "VF DE"],
  ["vod.de.wl.mgd", "VF DE"],
  ["vod.de.wl.slb", "VF DE"],
  ["vod.de.wl.sle", "VF DE"],
  ["vod.de.wl.ssm", "VF DE"],
  ["vod.decom", "VCI"],
  ["vod.eg.decom", "VF EG"],
  ["vod.eg.migr.mgd", "VF EG"],
  ["vod.eg.migr.ssm", "VF EG"],
  ["vod.es.decom", "VF ES"],
  ["vod.es.migr.mgd", "VF ES"],
  ["vod.es.migr.ssm", "VF ES"],
  ["vod.gr.decom", "VF GR"],
  ["vod.gr.migr.mgd", "VF GR"],
  ["vod.gr.migr.ssm", "VF GR"],
  ["vod.gr.plt.conn", "VF GR"],
  ["vod.gr.plt.id", "VF GR"],
  ["vod.gr.plt.mgmt", "VF GR"],
  ["vod.gr.plt.migr", "VF GR"],
  ["vod.gr.plt.sec", "VF GR"],
  ["vod.gr.sbox", "VF GR"],
  ["vod.gr.wl.mgd", "VF GR"],
  ["vod.gr.wl.slb", "VF GR"],
  ["vod.gr.wl.sle", "VF GR"],
  ["vod.gr.wl.ssm", "VF GR"],
  ["vod.group.cis.decom", "Group CIS"],
  ["vod.group.cis.plt.mgmt", "Group CIS"],
  ["vod.group.cis.sbox", "Group CIS"],
  ["vod.group.cis.wl.mgd", "Group CIS"],
  ["vod.group.cis.wl.ssm", "Group CIS"],
  ["vod.group.cs.decom", "CYBER SECURITY"],
  ["vod.group.cs.sbox", "CYBER SECURITY"],
  ["vod.group.cs.wl.mgd", "CYBER SECURITY"],
  ["vod.group.cs.wl.ssm", "CYBER SECURITY"],
  ["vod.group.decom", "VCI"],
  ["vod.group.dt.online.mgd", "Group Digital Twin"],
  ["vod.group.dt.online.ssm", "Group Digital Twin"],
  ["vod.group.dt.wl.ssm", "Group Digital Twin"],
  ["vod.group.fin.decom", "Group Finance"],
  ["vod.group.fin.sbox", "Group Finance"],
  ["vod.group.fin.wl.mgd", "Group Finance"],
  ["vod.group.fin.wl.ssm", "Group Finance"],
  ["vod.group.it4it.decom", "IT4IT"],
  ["vod.group.it4it.plt.mgmt", "IT4IT"],
  ["vod.group.it4it.sbox", "IT4IT"],
  ["vod.group.it4it.wl.mgd", "IT4IT"],
  ["vod.group.it4it.wl.ssm", "IT4IT"],
  ["vod.group.itsa.decom", "Group Architecture"],
  ["vod.group.itsa.sbox", "Group Architecture"],
  ["vod.group.itsa.wl.mgd", "Group Architecture"],
  ["vod.group.itsa.wl.ssm", "Group Architecture"],
  ["vod.group.migr.decom", "VCI"],
  ["vod.group.migr.mgd", "VCI"],
  ["vod.group.migr.ssm", "AI Booster"],
  ["vod.group.netw.aib", "NETWORKS"],
  ["vod.group.netw.decom", "NETWORKS"],
  ["vod.group.netw.sbox", "NETWORKS"],
  ["vod.group.netw.wl.mgd", "NETWORKS"],
  ["vod.group.netw.wl.ssm", "NETWORKS"],
  ["vod.group.oit.decom", "Oit-Coll-Billing"],
  ["vod.group.oit.migr.ssm", "Oit-Coll-Billing"],
  ["vod.group.oit.sbox", "Oit-Coll-Billing"],
  ["vod.group.oit.wl.mgd", "Oit-Coll-Billing"],
  ["vod.group.oit.wl.ssm", "Oit-Coll-Billing"],
  ["vod.group.plt.conn", "VCI"],
  ["vod.group.plt.id", "VCI"],
  ["vod.group.plt.mgmt", "VCI"],
  ["vod.group.plt.sec", "VCI"],
  ["vod.group.sbox", "VCI"],
  ["vod.group.vci.decom", "VCI"],
  ["vod.group.vci.plt.mgmt", "VCI"],
  ["vod.group.vci.sbox", "VCI"],
  ["vod.group.vci.wl.mgd", "VCI"],
  ["vod.group.vci.wl.ssm", "VCI"],
  ["vod.group.vits.decom", "VCI"],
  ["vod.group.vits.sbox", "VCI"],
  ["vod.group.vits.wl.mgd", "VCI"],
  ["vod.group.vits.wl.ssm", "VCI"],
  ["vod.group.voishu.decom", "_vois hungary"],
  ["vod.group.voishu.sbox", "_vois hungary"],
  ["vod.group.voishu.wl.mgd", "_vois hungary"],
  ["vod.group.voishu.wl.ssm", "_vois hungary"],
  ["vod.group.voisin.decom", "VOIS INDIA"],
  ["vod.group.voisin.online", "VOIS INDIA"],
  ["vod.group.voisin.sbox", "VOIS INDIA"],
  ["vod.group.voisin.wl.mgd", "VOIS INDIA"],
  ["vod.group.voisin.wl.ssm", "VOIS INDIA"],
  ["vod.group.vvbit.plt.mgmt", "VODAFONE BUSINESS IT"],
  ["vod.group.vvbit.sbox", "VODAFONE BUSINESS IT"],
  ["vod.group.vvbit.wl.mgd", "VODAFONE BUSINESS IT"],
  ["vod.group.vvbit.wl.ssm", "VODAFONE BUSINESS IT"],
  ["vod.group.wl.slb", "VCI"],
  ["vod.ie.decom", "VF IE"],
  ["vod.ie.migr.mgd", "VF IE"],
  ["vod.ie.migr.ssm", "VF IE"],
  ["vod.ie.plt.conn", "VF IE"],
  ["vod.ie.plt.id", "VF IE"],
  ["vod.ie.plt.mgmt", "VF IE"],
  ["vod.ie.plt.migr", "VF IE"],
  ["vod.ie.plt.sec", "VF IE"],
  ["vod.ie.sbox", "VF IE"],
  ["vod.ie.wl.mgd", "VF IE"],
  ["vod.ie.wl.slb", "VF IE"],
  ["vod.ie.wl.sle", "VF IE"],
  ["vod.ie.wl.ssm", "VF IE"],
  ["vod.it.decom", "VF IT"],
  ["vod.it.migr.mgd", "VF IT"],
  ["vod.it.migr.ssm", "VF IT"],
  ["vod.it.plt.conn", "VF IT"],
  ["vod.it.plt.id", "VF IT"],
  ["vod.it.plt.mgmt", "VF IT"],
  ["vod.it.plt.migr", "VF IT"],
  ["vod.it.plt.sec", "VF IT"],
  ["vod.it.sbox", "VF IT"],
  ["vod.it.wl.mgd", "VF IT"],
  ["vod.it.wl.slb", "VF IT"],
  ["vod.it.wl.sle", "VF IT"],
  ["vod.it.wl.ssm.next", "VF IT"],
  ["vod.lu.decom", "VF LU"],
  ["vod.lu.migr.mgd", "VF LU"],
  ["vod.lu.migr.ssm", "VF LU"],
  ["vod.migr.decom", "VCI"],
  ["vod.migr.plt.conn", "VCI"],
  ["vod.migr.plt.id", "VCI"],
  ["vod.migr.plt.mgmt", "VCI"],
  ["vod.migr.plt.migr", "VCI"],
  ["vod.migr.plt.sec", "VCI"],
  ["vod.migr.sbox", "VCI"],
  ["vod.migr.wl.mgd.group.vci", "VCI"],
  ["vod.migr.wl.ssm.cz", "VF CZ"],
  ["vod.migr.wl.ssm.de", "VF DE"],
  ["vod.migr.wl.ssm.gr", "VF GR"],
  ["vod.migr.wl.ssm.ie", "VF IE"],
  ["vod.migr.wl.ssm.it", "VF IT"],
  ["vod.migr.wl.ssm.pt", "VF PT"],
  ["vod.migr.wl.ssm.ro", "VF RO"],
  ["vod.migr.wl.ssm.uk", "VF UK"],
  ["vod.pt.decom", "VF PT"],
  ["vod.pt.migr.mgd", "VF PT"],
  ["vod.pt.migr.ssm", "VF PT"],
  ["vod.pt.plt.conn", "VF PT"],
  ["vod.pt.plt.id", "VF PT"],
  ["vod.pt.plt.mgmt", "VF PT"],
  ["vod.pt.plt.migr", "VF PT"],
  ["vod.pt.plt.sec", "VF PT"],
  ["vod.pt.sbox", "VF PT"],
  ["vod.pt.wl.mgd", "VF PT"],
  ["vod.pt.wl.slb", "VF PT"],
  ["vod.pt.wl.sle", "VF PT"],
  ["vod.pt.wl.ssm", "VF PT"],
  ["vod.restricted", "VCI"],
  ["vod.ro.decom", "VF RO"],
  ["vod.ro.migr.mgd", "VF RO"],
  ["vod.ro.migr.ssm", "VF RO"],
  ["vod.ro.plt.conn", "VF RO"],
  ["vod.ro.plt.id", "VF RO"],
  ["vod.ro.plt.mgmt", "VF RO"],
  ["vod.ro.plt.migr", "VF RO"],
  ["vod.ro.plt.sec", "VF RO"],
  ["vod.ro.sbox", "VF RO"],
  ["vod.ro.wl.mgd", "VF RO"],
  ["vod.ro.wl.slb", "VF RO"],
  ["vod.ro.wl.sle", "VF RO"],
  ["vod.ro.wl.ssm", "VF RO"],
  ["vod.sbox", "VCI"],
  ["vod.shp.conn", "VCI"],
  ["vod.shp.hci", "VCI"],
  ["vod.shp.id", "VCI"],
  ["vod.shp.mgmt", "VCI"],
  ["vod.shp.sec", "VCI"],
  ["vod.taas.decom", "DIGITAL ENGINEERING AND IT ARCHITECTURE"],
  ["vod.taas.plt.conn", "DIGITAL ENGINEERING AND IT ARCHITECTURE"],
  ["vod.taas.plt.id", "DIGITAL ENGINEERING AND IT ARCHITECTURE"],
  ["vod.taas.plt.mgmt", "DIGITAL ENGINEERING AND IT ARCHITECTURE"],
  ["vod.taas.plt.sec", "DIGITAL ENGINEERING AND IT ARCHITECTURE"],
  ["vod.taas.plt.vciconn", "DIGITAL ENGINEERING AND IT ARCHITECTURE"],
  ["vod.taas.sbox", "DIGITAL ENGINEERING AND IT ARCHITECTURE"],
  ["vod.taas.wl.cz", "DIGITAL ENGINEERING AND IT ARCHITECTURE"],
  ["vod.taas.wl.de", "DIGITAL ENGINEERING AND IT ARCHITECTURE"],
  ["vod.taas.wl.gr", "DIGITAL ENGINEERING AND IT ARCHITECTURE"],
  ["vod.taas.wl.ie", "DIGITAL ENGINEERING AND IT ARCHITECTURE"],
  ["vod.taas.wl.it", "DIGITAL ENGINEERING AND IT ARCHITECTURE"],
  ["vod.taas.wl.pt", "DIGITAL ENGINEERING AND IT ARCHITECTURE"],
  ["vod.taas.wl.ro", "DIGITAL ENGINEERING AND IT ARCHITECTURE"],
  ["vod.taas.wl.uk", "DIGITAL ENGINEERING AND IT ARCHITECTURE"],
  ["vod.tr.decom", "VF TR"],
  ["vod.tr.migr.mgd", "VF TR"],
  ["vod.tr.migr.ssm", "VF TR"],
  ["vod.tr.plt.conn", "VF TR"],
  ["vod.tr.plt.id", "VF TR"],
  ["vod.tr.plt.mgmt", "VF TR"],
  ["vod.tr.plt.sec", "VF TR"],
  ["vod.tr.sbox", "VF TR"],
  ["vod.tr.wl.ssm", "VF TR"],
  ["vod.tz.decom", "VC TZ"],
  ["vod.tz.migr.mgd", "VC TZ"],
  ["vod.tz.migr.ssm", "VC TZ"],
  ["vod.uk.aib", "VF UK"],
  ["vod.uk.decom", "VF UK"],
  ["vod.uk.migr.mgd", "VF UK"],
  ["vod.uk.migr.ssm", "VF UK"],
  ["vod.uk.plt.conn", "VF UK"],
  ["vod.uk.plt.id", "VF UK"],
  ["vod.uk.plt.mgmt", "VF UK"],
  ["vod.uk.plt.migr", "VF UK"],
  ["vod.uk.plt.sec", "VF UK"],
  ["vod.uk.sbox", "VF UK"],
  ["vod.uk.wl.mgd", "VF UK"],
  ["vod.uk.wl.slb", "VF UK"],
  ["vod.uk.wl.sle", "VF UK"],
  ["vod.uk.wl.ssm", "VF UK"],
  ["vod.za.decom", "VF ZA"],
  ["vod.za.migr.mgd", "VF ZA"],
  ["vod.za.migr.ssm", "VF ZA"],
  ["vod.ziggo.decom", "VF ZIGGO"],
  ["vod.ziggo.migr.mgd", "VF ZIGGO"],
  ["vod.ziggo.migr.ssm", "VF ZIGGO"],
  ["vodstg.cz.decom", "VCI"],
  ["vodstg.cz.online.aib", "VCI"],
  ["vodstg.cz.plt.conn", "VCI"],
  ["vodstg.cz.plt.id", "VCI"],
  ["vodstg.cz.plt.mgmt", "VCI"],
  ["vodstg.cz.plt.migr", "VCI"],
  ["vodstg.cz.plt.sec", "VCI"],
  ["vodstg.cz.sbox", "VCI"],
  ["vodstg.cz.wl.mgd", "VCI"],
  ["vodstg.cz.wl.ssm", "VCI"],
  ["vodstg.de.decom", "VCI"],
  ["vodstg.de.plt.conn", "VCI"],
  ["vodstg.de.plt.id", "VCI"],
  ["vodstg.de.plt.mgmt", "VCI"],
  ["vodstg.de.plt.migr", "VCI"],
  ["vodstg.de.plt.sec", "VCI"],
  ["vodstg.de.sbox", "VCI"],
  ["vodstg.de.wl.mgd", "VCI"],
  ["vodstg.de.wl.slb", "VCI"],
  ["vodstg.de.wl.sle", "VCI"],
  ["vodstg.de.wl.slf", "VCI"],
  ["vodstg.de.wl.ssm", "VCI"],
  ["vodstg.decom", "VCI"],
  ["vodstg.gr.decom", "VCI"],
  ["vodstg.gr.plt.conn", "VCI"],
  ["vodstg.gr.plt.id", "VCI"],
  ["vodstg.gr.plt.mgmt", "VCI"],
  ["vodstg.gr.plt.migr", "VCI"],
  ["vodstg.gr.plt.sec", "VCI"],
  ["vodstg.gr.sbox", "VCI"],
  ["vodstg.gr.wl.mgd", "VCI"],
  ["vodstg.gr.wl.slb", "VCI"],
  ["vodstg.gr.wl.sle", "VCI"],
  ["vodstg.gr.wl.slf", "VCI"],
  ["vodstg.gr.wl.ssm", "VCI"],
  ["vodstg.group.cs.decom", "VCI"],
  ["vodstg.group.cs.sbox", "VCI"],
  ["vodstg.group.cs.wl.mgd", "VCI"],
  ["vodstg.group.cs.wl.ssm", "VCI"],
  ["vodstg.group.fin.decom", "VCI"],
  ["vodstg.group.fin.sbox", "VCI"],
  ["vodstg.group.fin.wl.mgd", "VCI"],
  ["vodstg.group.fin.wl.ssm", "VCI"],
  ["vodstg.group.it4it.decom", "VCI"],
  ["vodstg.group.it4it.sbox", "VCI"],
  ["vodstg.group.it4it.wl.mgd", "VCI"],
  ["vodstg.group.it4it.wl.ssm", "VCI"],
  ["vodstg.group.itsa.decom", "VCI"],
  ["vodstg.group.itsa.sbox", "VCI"],
  ["vodstg.group.itsa.wl.mgd", "VCI"],
  ["vodstg.group.itsa.wl.ssm", "VCI"],
  ["vodstg.group.oit.decom", "VCI"],
  ["vodstg.group.oit.sbox", "VCI"],
  ["vodstg.group.oit.wl.mgd", "VCI"],
  ["vodstg.group.oit.wl.ssm", "VCI"],
  ["vodstg.group.vci.decom", "VCI"],
  ["vodstg.group.vci.sbox", "VCI"],
  ["vodstg.group.vci.wl.mgd", "VCI"],
  ["vodstg.group.vci.wl.ssm", "VCI"],
  ["vodstg.ie.decom", "VCI"],
  ["vodstg.ie.plt.conn", "VCI"],
  ["vodstg.ie.plt.id", "VCI"],
  ["vodstg.ie.plt.mgmt", "VCI"],
  ["vodstg.ie.plt.migr", "VCI"],
  ["vodstg.ie.plt.sec", "VCI"],
  ["vodstg.ie.sbox", "VCI"],
  ["vodstg.ie.wl.mgd", "VCI"],
  ["vodstg.ie.wl.slb", "VCI"],
  ["vodstg.ie.wl.sle", "VCI"],
  ["vodstg.ie.wl.ssm", "VCI"],
  ["vodstg.it.decom", "VCI"],
  ["vodstg.it.plt.conn", "VCI"],
  ["vodstg.it.plt.id", "VCI"],
  ["vodstg.it.plt.mgmt", "VCI"],
  ["vodstg.it.plt.migr", "VCI"],
  ["vodstg.it.plt.sec", "VCI"],
  ["vodstg.it.sbox", "VCI"],
  ["vodstg.it.wl.mgd", "VCI"],
  ["vodstg.it.wl.slb", "VCI"],
  ["vodstg.it.wl.sle", "VCI"],
  ["vodstg.it.wl.ssm", "VCI"],
  ["vodstg.pt.decom", "VCI"],
  ["vodstg.pt.plt.conn", "VCI"],
  ["vodstg.pt.plt.id", "VCI"],
  ["vodstg.pt.plt.mgmt", "VCI"],
  ["vodstg.pt.plt.migr", "VCI"],
  ["vodstg.pt.plt.sec", "VCI"],
  ["vodstg.pt.sbox", "VCI"],
  ["vodstg.pt.wl.mgd", "VCI"],
  ["vodstg.pt.wl.slb", "VCI"],
  ["vodstg.pt.wl.sle", "VCI"],
  ["vodstg.pt.wl.slf", "VCI"],
  ["vodstg.pt.wl.ssm", "VCI"],
  ["vodstg.region.plt", "VCI"],
  ["vodstg.region.wl", "VCI"],
  ["vodstg.restricted", "VCI"],
  ["vodstg.ro.decom", "VCI"],
  ["vodstg.ro.plt.conn", "VCI"],
  ["vodstg.ro.plt.id", "VCI"],
  ["vodstg.ro.plt.mgmt", "VCI"],
  ["vodstg.ro.plt.migr", "VCI"],
  ["vodstg.ro.plt.sec", "VCI"],
  ["vodstg.ro.sbox", "VCI"],
  ["vodstg.ro.wl.mgd", "VCI"],
  ["vodstg.ro.wl.slb", "VCI"],
  ["vodstg.ro.wl.sle", "VCI"],
  ["vodstg.ro.wl.slf", "VCI"],
  ["vodstg.ro.wl.ssm", "VCI"],
  ["vodstg.sbox", "VCI"],
  ["vodstg.shp.conn", "VCI"],
  ["vodstg.shp.hci", "VCI"],
  ["vodstg.shp.id", "VCI"],
  ["vodstg.shp.mgmt", "VCI"],
  ["vodstg.shp.sec", "VCI"],
  ["vodstg.uk.decom", "VCI"],
  ["vodstg.uk.online.aib", "VCI"],
  ["vodstg.uk.plt.conn", "VCI"],
  ["vodstg.uk.plt.id", "VCI"],
  ["vodstg.uk.plt.mgmt", "VCI"],
  ["vodstg.uk.plt.migr", "VCI"],
  ["vodstg.uk.plt.sec", "VCI"],
  ["vodstg.uk.sbox", "VCI"],
  ["vodstg.uk.wl.mgd", "VCI"],
  ["vodstg.uk.wl.slb", "VCI"],
  ["vodstg.uk.wl.sle", "VCI"],
  ["vodstg.uk.wl.ssm", "VCI"],
]);
